import { Injectable } from '@angular/core';
import {WmHttpService} from "@wms/services";
import { environment } from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  API_META = {
    login: {
      url: environment.SERVICES_BASE_PATH + "services/auth/loginservice",
      method: 'POST'
    },
    logout: {
      url: environment.SERVICES_BASE_PATH + "services/auth/logoutservice",
      method: "GET"
    },
    fetch: {
      url: "/login/rest/profile",
      method: "GET",
      embedModeAPI: true
    },
    update: {
      url: "/login/rest/profile",
      method: "PUT"
    },
    updatePassword: {
      url: "/login/rest/profile/password",
      method: "PUT"
    },
    isFormLogin: {
      url: "/login/rest/no-auth/is-form-login",
      method: "GET"
    },
    getSupportedLocales: {
      url: "/login/rest/supported-locales",
      method: "GET"
    },
    resendVerificationEmail: {
      url: "/login/rest/profile/resend-verification-mail",
      method: "POST"
    }
  };
  TARGET = 'USER';
  private userDetails: any;

  constructor(private wmHttpService: WmHttpService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }

  fetch() : Promise<any>{
    return (this.wmHttpService.execute({target: this.TARGET, action: 'fetch'}) as Promise<any>)
      .then((data) => {
        this.set(data)
      });
  }

  get(): any {
    return this.userDetails;
  }

  set(data: any) {
    this.userDetails = data;
  }

  login(data:any) : Promise<any> {
    return this.wmHttpService.execute({target: this.TARGET, action: 'login', data: data}) as Promise<any>;
  }

  isFormLogin(): Promise<any> {
    return this.wmHttpService.execute({target: this.TARGET, action: 'isFormLogin'}) as Promise<any>;
  }


  logout(): Promise<any> {
    return this.wmHttpService.execute(
      {
        target: this.TARGET,
        action: 'logout'
      }) as Promise<any>;
  }

  resendVerificationEmail(): Promise<any> {
    return this.wmHttpService.execute(
      {
        target: this.TARGET,
        action: 'resendVerificationEmail'
      }) as Promise<any>;
  }
}
